module.exports = __webpack_public_path__ + "img/icon_ppt.75875645.svg";